<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <b-avatar
        size="40"
        :src="userData.picture"
        variant="light-primary"
      />
    </template>
    <b-dropdown-item link-class="d-flex align-items-center avatar-with-info">
      <b-avatar
        size="40"
        :src="userData.picture"
        variant="light-primary"
      >
        <feather-icon
          v-if="!userData.picture"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
      <div class="dropdown-username-role pl-1">
        <span
          v-if="checkIfUserFullData()"
          class="dropdown__username-header"
        >{{ userData.given_name }} {{ userData.family_name }}</span>
        <span
          v-if="!checkIfUserFullData()"
          class="dropdown__username-header dropdown__username-header--transform"
        >
          <span v-if="userData.displayName">
            {{ userData.displayName }}
          </span>
          <span v-else>
            {{ userData.email }}
          </span>
        </span>
        <span class="dropdown__username-email">{{ userData.email }}</span>
      </div>
    </b-dropdown-item>
    <div v-if="!adminPlatform">
      <b-dropdown-item
        v-if="configuration && configuration.clientConfiguration && configuration.clientConfiguration.oldClientUrl"
        :href="configuration.clientConfiguration.oldClientUrl"
        link-class="d-flex align-items-center"
        target="_blank"
      >
        <GjIcon
          class="mr-50"
          name="Analytics"
          size="24"
        />
        <span>{{ $tk('ClientPortal.UserMenu.OldStatistics') }}</span>
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item
        :to="{ name: 'settings' }"
        link-class="d-flex align-items-center"
      >
        <GjIcon
          class="mr-50"
          name="Avatar"
        />
        <span>{{ $tk('ClientPortal.SideMenu.Profile') }}</span>
      </b-dropdown-item>
    </div>
    <template v-if="platformAccessManager.hasAccessInAdmin()">
      <b-dropdown-divider />
      <b-dropdown-item
        link-class="d-flex align-items-center"
        @click="changePlatform"
      >
        <GjIcon
          class="mr-50"
          name="Switch"
        />
        <span v-if="!adminPlatform">{{ $tk('ClientPortal.SideMenu.SwitchToAdmin') }}</span>
        <span v-else>{{ $tk('ClientPortal.SideMenu.SwitchToPlatform') }}</span>
      </b-dropdown-item>
    </template>
    <b-dropdown-divider />
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="goToSubscriptions"
    >
      <GjIcon
        class="mr-50"
        name="Notifications"
      />
      <span>{{ $tk('ClientPortal.SideMenu.Subscriptions') }}</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <div v-if="locales.length > 1 && !adminPlatform">
      <b-link
        v-b-toggle:languages
        class="dropdown-item d-flex justify-content-between"
        variant="link-secondary"
      >
        <div>
          <GjIcon
            class="mr-50"
            name="Language"
          />
          <span>{{ currentLocale.name }}</span>
        </div>
        <span v-if="collapsed">
          <GjIcon
            :key="`up${collapsed}`"
            class="ml-50"
            name="ArrowUp"
          />
        </span>
        <span v-else>
          <GjIcon
            :key="`down${collapsed}`"
            class="ml-50"
            name="ArrowDown"
          />
        </span>
      </b-link>
      <b-collapse
        id="languages"
        v-model="collapsed"
      >
        <b-link
          v-for="localeObj in locales"
          :key="localeObj.uniqueSeoCode"
          class="dropdown-item d-flex align-items-center"
          variant="link-secondary"
          @click="changeLocaleLanguage(localeObj)"
        >
          <div class="d-flex align-items-center h-20px">
            <country-flag
              :country="localeObj.uniqueSeoCode"
              size="normal"
              class="country__flag"
            />
            <span :class="`ml-50 ${currentLocale.name === localeObj.name ? 'text-primary': ''}`">{{ localeObj.name }} </span>
          </div>

        </b-link>
      </b-collapse>
      <b-dropdown-divider />
    </div>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <GjIcon
        class="mr-50 rotated"
        name="Signout"
      />
      <span> {{ $tk('ClientPortal.UserMenu.Logout') }} </span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { avatarText } from '@core/utils/filter'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import { mapGetters } from 'vuex'
import { PlatformAccessManager } from '@/utils/accessManager/accessManager'
import LanguageService from '@/api/client/language.service'
import CountryFlag from 'vue-country-flag'
import { logoutUser } from '../../../../../../GjirafaFront/script/auth'

export default {
  components: {
    GjIcon,
    CountryFlag,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      avatarText,
      platformAccessManager: PlatformAccessManager,
      locales: [],
      collapsed: false,
    }
  },
  computed: {
    ...mapGetters(['configuration']),
    ...mapGetters('verticalMenu', ['adminPlatform']),
    currentLocale() {
      return this.locales.length > 0 ? this.locales.find(l => l.uniqueSeoCode === this.$i18n.locale) : {}
    },
  },
  async created() {
    this.locales = await LanguageService.getLanguages()
  },
  methods: {
    logout() {
      localStorage.clear()
      logoutUser('auth-login')
    },
    checkIfUserFullData() {
      return !!(this.userData.given_name && this.userData.family_name)
    },
    changePlatform() {
      this.collapsed = false
      const adminPlatform = this.$store.getters['verticalMenu/adminPlatform']
      const { accountId } = this.$store.getters['verticalMenu/accountContext']
      if (this.adminPlatform) { this.$router.push(accountId ? `/${accountId}` : '/') } else { this.$router.push('/admin/accounts') }
      this.$store.commit('verticalMenu/changePlatform', !adminPlatform)
    },
    goToSubscriptions() {
      this.$router.push({ name: 'subscriptions' })

      this.$emit('toggleToSubscriptions')
    },
    changeLocaleLanguage(locale) {
      this.$i18n.locale = locale.uniqueSeoCode
      LanguageService.changeUserPreferences(locale.id)
    },
  },
}
</script>
